!function () {
	if (window.golfbox === undefined) {
		window.golfbox = window.gb = {};
	}

	let _ = {};
    window.gb.modal = _;

    let store = {};

    _.add = function (id) {
        store[id] = {
            element: $('#' + id),
            hide: function () {
                this.element.addClass('hidden');
                return this;
            },
            show: function () {
                this.element.removeClass('hidden');
                return this;
            },
            params: function (params) {
                if (params) {
                    this._params = params;
                    return this;
                } else {
                    return this._params;
                }
            }
        };
    };

    _.get = function (id) {
        return store[id];
    };
}()